export const safeParse = (input) => {
    try {
        return JSON.parse(input ?? '');
    }
    catch {
        return null;
    }
};
//# sourceMappingURL=safeParse.js.map